module.exports = __webpack_public_path__ + "assets/fonts/EBGaramond-ExtraBoldItalic.5f877886.ttf";